// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#3277a3","lightPrimary":"#3f5868","secondaryColor":"#db633d","lightSecondary":"#b8e4f0","darkPrimaryColor":"#103246","cellHeight":"60px"};